import Keycloak from 'keycloak-js';
import axios from 'axios';
// Instantiate Keycloak once, pointing at your realm and SPA client
const { protocol, host } = window.location; // host includes port if non-default

export const keycloak = new Keycloak({
  realm: "DESMA",
  url: `${protocol}//${host}/auth/`,
  clientId: "flask-frontend",
});

export const initOptions = {
  onLoad: 'check-sso',
  //onLoad: 'login-required',                   // perform a silent session
  flow: 'standard',                         // use the OIDC Authorization Code Flow
  pkceMethod: 'S256',                       // enforce PKCE for extra SPA security
  //silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  checkLoginIframe: true,                   // enable the hidden iframe for silent token refresh
  checkLoginIframeInterval: 5,             // polling interval in seconds
  enableLogging: true,                // turn on adapter debug logging
  //checkLoginIframe: false
};

export const onKeycloakTokens = (tokens) => {
    console.log('onKeycloakTokens', tokens)
}

export const eventLogger = (event, error) => {
  console.log('onKeycloakEvent', event, error)
  if(event && event === 'onAuthSuccess'){
    axios.post(`/api/authUser`, {"User":keycloak.tokenParsed?.preferred_username}).then(res=>{
      console.log(res)
    })

  }
}
